import React from 'react'
import './anniheroflowers.css';

function AnniHeroFlowers({currentEvent}) {
   
    function calculateYearsMarried(weddingDateString) {
        
        const [year, month, day] = weddingDateString.split('-').map(Number);
        const weddingDate = new Date(year, month - 1, day); // Month is 0-indexed
        const currentDate = new Date();

        const timeDifference = currentDate.getTime() - weddingDate.getTime();
        const yearsDifference = timeDifference / (1000 * 3600 * 24 * 365.25); // Account for leap years
        
        if (yearsDifference >= 1) {
            return Math.round(yearsDifference);
        } else {
            return "";
        }
    }

  return (
    <div className="intro-anniver-section ">
        <img className="flower-intro pinkCornors pos14 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/pinkish_flowers_cartoon_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro mainRoses pos2  no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/red_flowers__cartoon-1_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro whitpurpse pos3 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/flower_purpnav_cartoon_01_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro mainRoses pos12 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/red_flowers__cartoon-1_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro redroses pos5 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/red_flowers__cartoon-1_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro pinkCornors pos6 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/pinkish_flowers_cartoon_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro mainRoses pos7 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/red_flowers__cartoon-1_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro whitelill pos11 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/white_flower_cartoon_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro pinkline pos15 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/light_flower_sky_pink_cartoon_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro whitpurpse pos9 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/flower_purpnav_cartoon_01_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro pinkline pos4 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/light_flower_sky_pink_cartoon_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro mainRoses pos10 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/red_flowers__cartoon-1_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro whitelill pos8 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/white_flower_cartoon_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        <img className="flower-intro whitpurpse pos13 no-mobile" src="https://loved.tsdevcut.co.za/wp-content/themes/lovedrip/images/flower_purpnav_cartoon_01_sm.png" alt="LoveDripp Logo Anniversary Flowers" />
        
        {
            currentEvent && (
                 <div className="st-content">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-5">
                                <div className="flexme numberingfl">
                                            <div className="large-anni-number">
                                               {calculateYearsMarried(currentEvent?.weddingDate)}                        
                                            </div>
                                            <div className="anni-content-1">
                                                <h2 className="top-title">Year Anniversary</h2>
                                                <div className="ann-copy">
                                                    Since <strong>{currentEvent?.weddingDate}</strong>, at 10:00 am. The location of their wedding 
                                                    ceremony was at {currentEvent?.weddingAddress?.address}.
                                                </div>
                                            </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="a-names mgtop50 mgmobilennospace">
                                    <h2 className="lg-large-text lg-title-1">
                                        {currentEvent.spouseA}
                                     </h2>
                                    <h2 className="lg-title-n ">
                                        &amp;
                                    </h2>
                                    <h2 className="lg-large-text lg-title-2">
                                      {currentEvent.spouseB}</h2>
                                </div>
                            </div>
                        <div className="col-md-3">
                                <div className="photo-anniver-contain tilt-left"> 
                                    <div className="photoframe photo">
                                        <div className="image-photo hnew" 
                                            style={{backgroundImage: `url("${currentEvent.featureUrl}")`}}>
                                            
                                        </div>
                                        <div className="mgbot30"></div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        
                    </div>
                </div>
            )
        }
    </div>
  )
}

export default AnniHeroFlowers